import React from "react";
import Predictor from "./components/Predictor";
import "./App.css";

function App() {
  return <Predictor />;
}

export default App;